export default __webpack_public_path__ + "static/media/ID_ANDY_DRAGOYLE_Kaiju.7d5ea96f.jpg";